export enum VmStatus {
  PREPARED = 'prepared',
  PROVISIONING = 'provisioning',
  CONTAINER_STARTED = 'container_started',
  RUNNING = 'running',
  STOPPED = 'stopped',
  FAILED = 'failed',
  TERMINATED = 'terminated',
  /** Azure VM deletion initiated; teardown is running in the background. */
  TERMINATING = 'terminating',
}
